export const RoadStretch = {
  GET_CITY_ROAD_STRETCHES: "GET_CITY_ROAD_STRETCHES",
  GET_CITY_ROAD_STRETCHES_SUCCESS: "GET_CITY_ROAD_STRETCHES_SUCCESS",
  GET_CITY_ROAD_STRETCHES_FAILURE: "GET_CITY_ROAD_STRETCHES_FAILURE",

  // Get Road Stretches by Stretch Ids Actions
  GET_ROAD_STRETCHES_BY_IDS: "GET_ROAD_STRETCHES_BY_IDS",
  GET_ROAD_STRETCHES_BY_IDS_SUCCESS: "GET_ROAD_STRETCHES_BY_IDS_SUCCESS",
  GET_ROAD_STRETCHES_BY_IDS_FAILURE: "GET_ROAD_STRETCHES_BY_IDS_FAILURE",

  // Get Road Stretches by Org Id
  GET_ROAD_STRETCHES_OF_ORG: "GET_ROAD_STRETCHES_OF_ORG",
  GET_ROAD_STRETCHES_OF_ORG_SUCCESS: "GET_ROAD_STRETCHES_OF_ORG_SUCCESS",
  GET_ROAD_STRETCHES_OF_ORG_FAILURE: "GET_ROAD_STRETCHES_OF_ORG_FAILURE",

  // get Road Stretch information by ID
  GET_ROAD_STRETCH_INFO_BY_ID: "GET_ROAD_STRETCH_INFO_BY_ID",
  GET_ROAD_STRETCH_INFO_BY_ID_SUCCESS: "GET_ROAD_STRETCH_INFO_BY_ID_SUCCESS",
  GET_ROAD_STRETCH_INFO_BY_ID_FAILURE: "GET_ROAD_STRETCH_INFO_BY_ID_FAILURE",

  // add/remove selected road-stretch
  ADD_SELECTED_ROAD_STRETCH: "ADD_SELECTED_ROAD_STRETCH",
  REMOVE_SELECTED_ROAD_STRETCH: "REMOVE_SELECTED_ROAD_STRETCH",

  // clear Selected Road-Stretch-Data from MapView
  CLEAR_ROAD_STRETCH_DATA: "CLEAR_ROAD_STRETCH_DATA",

  // Archive and Restore Stretch
  ARCHIVE_ROAD_STRETCH: "ARCHIVE_ROAD_STRETCH",
  ARCHIVE_ROAD_STRETCH_SUCCESS: "ARCHIVE_ROAD_STRETCH_SUCCESS",
  ARCHIVE_ROAD_STRETCH_FAILURE: "ARCHIVE_ROAD_STRETCH_FAILURE",

  // get multiple routes
  GET_MULTIPLE_ROUTES: "GET_MULTIPLE_ROUTES",
  GET_MULTIPLE_ROUTES_SUCCESS: "GET_MULTIPLE_ROUTES_SUCCESS",
  GET_MULTIPLE_ROUTES_FAILURE: "GET_MULTIPLE_ROUTES_FAILURE",

  // get waypoints route
  GET_WAYPOINTS_ROUTE: "GET_WAYPOINTS_ROUTE",
  GET_WAYPOINTS_ROUTE_SUCCESS: "GET_WAYPOINTS_ROUTE_SUCCESS",
  GET_WAYPOINTS_ROUTE_FAILURE: "GET_WAYPOINTS_ROUTE_FAILURE",
  CLEAR_WAYPOINTS_ROUTE: "CLEAR_WAYPOINTS_ROUTE",

  // Refresh Pricing
  ROAD_STRETCH_PRICE_REFRESH: "ROAD_STRETCH_PRICE_REFRESH",
  ROAD_STRETCH_PRICE_REFRESH_SUCCESS: "ROAD_STRETCH_PRICE_REFRESH_SUCCESS",
  ROAD_STRETCH_PRICE_REFRESH_FAILURE: "ROAD_STRETCH_PRICE_REFRESH_FAILURE",

  RESTORE_ROAD_STRETCH: "RESTORE_ROAD_STRETCH",
  RESTORE_ROAD_STRETCH_SUCCESS: "RESTORE_ROAD_STRETCH_SUCCESS",
  RESTORE_ROAD_STRETCH_FAILURE: "RESTORE_ROAD_STRETCH_FAILURE",

  UPDATE_ROAD_STRETCH_STATUS: "UPDATE_ROAD_STRETCH_STATUS",

  // Actions Related to Road Stretch Selection
  SELECT_ROAD_STRETCH: "SELECT_ROAD_STRETCH",
  SELECT_ROAD_STRETCHES: "SELECT_ROAD_STRETCHES",
  UN_SELECT_ROAD_STRETCH: "UN_SELECT_ROAD_STRETCH",
  SELECT_MULTI_ROAD_STRETCHES: "SELECT_MULTI_ROAD_STRETCHES",
  UN_SELECT_MULTI_ROAD_STRETCHES: "UN_SELECT_MULTI_ROAD_STRETCHES",

  // Reset
  RESET_ROAD_STRETCHES: "RESET_ROAD_STRETCHES",

  // Rest Selected Road Stretches
  RESET_SELECTED_ROAD_STRETCHES_IN_MAP_VIEW:
    "RESET_SELECTED_ROAD_STRETCHES_IN_MAP_VIEW",

  // to Add All Selected Road-Stretches while "restoring-save-map-state"
  ADD_ALL_SELECTED_ROAD_STRETCHES: "ADD_ALL_SELECTED_ROAD_STRETCHES",

  // Road stretch meta data form
  OPEN_ROAD_STRETCH_META_DATA_UPDATE_FORM:
    "OPEN_ROAD_STRETCH_META__DATA_UPDATE_FORM",
  CLOSE_ROAD_STRETCH_META_DATA_UPDATE_FORM:
    "CLOSE__ROAD_STRETCH_META__DATA_UPDATE_FORM",

  // Update road stretch meta data
  UPDATE_ROAD_STRETCH_META_DATA: "UPDATE_ROAD_STRETCH_META_DATA",
  UPDATE_ROAD_STRETCH_META_DATA_SUCCESS:
    "UPDATE_ROAD_STRETCH_META_DATA_SUCCESS",
  UPDATE_ROAD_STRETCH_META_DATA_FAILURE:
    "UPDATE_ROAD_STRETCH_META_DATA_FAILURE",

  // Update road stretch
  UPDATE_ROAD_STRETCH: "UPDATE_ROAD_STRETCH",
  UPDATE_ROAD_STRETCH_SUCCESS: "UPDATE_ROAD_STRETCH_SUCCESS",
  UPDATE_ROAD_STRETCH_FAILURE: "UPDATE_ROAD_STRETCH_FAILURE",

  // Get Touch Points Filtered Stretches
  GET_TOUCH_POINTS_FILTERED_STRETCHES: "GET_TOUCH_POINTS_FILTERED_STRETCHES",

  // Filter City Road Stretches (Zone, MediaType, RouteType)
  FILTER_CITY_ROAD_STRETCHES: "FILTER_CITY_ROAD_STRETCHES",

  // restore applied Filters Details Map
  RESTORE_APPLIED_FILTERS_DETAILS_MAP: "RESTORE_APPLIED_FILTERS_DETAILS_MAP",

  // Get FOL (freq opt loc) Filtered Stretches
  GET_FOL_FILTERED_STRETCHES: "GET_FOL_FILTERED_STRETCHES",

  // Road stretch media details form
  OPEN_ROAD_STRETCH_MEDIAS_DETAILS_FORM:
    "OPEN_ROAD_STRETCH_MEDIAS_DETAILS_FORM",
  CLOSE_ROAD_STRETCH_MEDIAS_DETAILS_FORM:
    "CLOSE_ROAD_STRETCH_MEDIAS_DETAILS_FORM",
};

export const CreateNewRoadStretches = {
  // for only "single-latLongString"
  GET_CLOSEST_ROAD_SG: "GET_CLOSEST_ROAD_SG_NEW_ROAD_STRETCH",
  GET_CLOSEST_ROAD_SG_SUCCESS: "GET_CLOSEST_ROAD_SG_SUCCESS_NEW_ROAD_STRETCH",
  GET_CLOSEST_ROAD_SG_FAILURE: "GET_CLOSEST_ROAD_SG_FAILURE_NEW_ROAD_STRETCH",

  // to clear closest road-segments
  RESET_CLOSEST_ROAD_SG: "RESET_CLOSEST_ROAD_SG",

  // select the segments for creating the stretch
  ADD_ROAD_SEGMENT: "ADD_ROAD_SEGMENT_NEW_ROAD_STRETCH",
  REMOVE_ROAD_SEGMENT: "REMOVE_ROAD_SEGMENT_NEW_ROAD_STRETCH",

  // Create Road Stretch
  CREATE_ROAD_STRETCH: "CREATE_ROAD_STRETCH",
  CREATE_ROAD_STRETCH_SUCCESS: "CREATE_ROAD_STRETCH_SUCCESS",
  CREATE_ROAD_STRETCH_FAILURE: "CREATE_ROAD_STRETCH_FAILURE",

  // Clear selections
  RESET: "RESET_ROAD_STRETCH_SELECTIONS",
};
